export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/infoIcon.87f7dbe4.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};